import i18n from '@/utils/i18n';
import React from 'react';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { NAVIGATION_TAB_LABELS } from '@/utils/navigation';
import { Text } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  focused: boolean;
  name: string;
}

export const DrawerLabel: React.FC<Props> = ({ focused, name }) => {
  const theme = useTheme();

  const label = NAVIGATION_TAB_LABELS[name];
  return (
    <Text
      // Ensure text does not wrap
      numberOfLines={1}
      style={[
        TYPOGRAPHY.small,
        FONTS.primaryBold,
        focused ? { color: theme.colors.accentText } : null,
      ]}
    >
      {label ? i18n.t(label) : name}
    </Text>
  );
};
